module.exports = __webpack_public_path__ + "static/media/tinywow_3012Fraxinus_colored_55475780.1bf76970.jpg";